<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline title="Franchisee payment Orders">
      <v-row>
        <v-col cols="12" sm="6" md="4">
          <v-dialog ref="dialog1" v-model="modal" :return-value.sync="fromDate" persistent width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field label="From Date" v-model="fromDate" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="fromDate" scrollable>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="modal = false">
                Cancel
              </v-btn>
              <v-btn text color="primary" @click="$refs.dialog1.save(fromDate)">
                OK
              </v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-dialog ref="dialog" v-model="modal1" :return-value.sync="toDate" persistent width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field label="To Date" v-model="toDate" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="toDate" scrollable>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="modal1 = false">
                Cancel
              </v-btn>
              <v-btn text color="primary" @click="$refs.dialog.save(toDate)">
                OK
              </v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>
      </v-row>
      <v-card-actions>
          <router-link :to="{ name: 'nodalView' }">
          <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>back</v-btn>
          <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10" style="opacity:.6;"> <v-icon>mdi-arrow-left</v-icon></v-btn>
          </router-link>
      </v-card-actions>
      <v-card-text class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
        <v-text-field
          :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
          v-model="search"
          append-icon="mdi-magnify"
          class="ml-auto mb-2"
          label="Search"
          hide-details
          single-line
          style="max-width:350px;"
        />
      </v-card-text>
      <v-divider class=" my-0 " />
      <v-data-table sort-by hide-default-footer :items-per-page="-1" :headers="headers" :items="tableData" :search="search" :single-expand="true" show-expand item-key="index">
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Franchisee payment Orders</v-toolbar-title>
          </v-toolbar>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length" class="pb-4 pt-4">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-center">
                      Student Name
                    </th>

                    <th class="text-center">
                      Class
                    </th>
                    <th class="text-center">
                      Fee Type
                    </th>
                    <th class="text-center">
                      Academic Year
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td align="center" justify="center">{{ item.notes.name }}</td>
                    <td align="center" justify="center">{{ item.notes.class }}</td>
                    <td align="center" justify="center">{{ item.notes.type }}</td>
                    <td align="center" justify="center">{{ item.notes.academicYear }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </td>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-row justify="end">
            <v-col>
              <v-btn class="px-2 ml-1 ma-1" v-if="isPendingOrder(item)" x-small color="blue" outlined @click="openDialog(dialogObj.types.payment, { orderID: item.id })">
                Reject Order
              </v-btn>
            </v-col>
          </v-row>
        </template>
      </v-data-table>
    </material-card>
    <loading-icon :value="isLoading" />
    <dialog-alert :dialogObj="dialogObj" v-model="dialogObj.show" @clicked="dialogClicked"></dialog-alert>
  </v-container>
</template>

<script>
import MaterialCard from '@/components/template/MaterialCard'
import DialogAlert from '@/components/template/DialogAlert'
import Utils from '@/utils'
import constants from '@/utils/constants'
import { mapGetters } from 'vuex'
import moment from 'moment'
import _ from 'lodash'
export default {
  components: { MaterialCard, DialogAlert },
  name: 'franchiseeOrderNodal',
  data () {
    return {
      dialogObj: {
        id: '',
        title: '',
        acceptName: '',
        rejectName: '',
        subtitle: '',
        show: false,
        params: {},
        isNo: true,
        isLoadingYes: false,
        isLoadingNo: false,
        types: {
          payment: 'PAYMENT'
        }
      },
      selectedOrderID: '',
      companyName: '',

      modal: false,
      modal1: false,
      fromDate: moment(new Date())
        .subtract(1, 'month')
        .format('YYYY-MM-DD'),
      toDate: new Date().toISOString().substr(0, 10),
      expanded: [],
      singleExpand: true,
      inProgress: false,
      search: '',
      franchiseeID: '',
      headers: [
        { text: 'Sr.No', sortable: true, value: 'index' },
        { text: 'Recipt No', sortable: true, value: 'receiptNo' },
        { text: 'status', value: 'status', sortable: true },
        { text: 'Payment ID', value: 'paymentID', sortable: true },
        { text: 'Enquiry Code', value: 'notes.enquiryCode', sortable: true },
        { text: 'Payment Status', value: 'paymentStatus', sortable: true },
        { text: 'Order Amount', value: 'amount', sortable: true },

        { text: 'Recipent', value: 'createdBy', sortable: true },
        { text: 'Created At', value: 'createdAt', sortable: true },
        { text: 'Payment Mode', value: 'paymentMode', sortable: true },
        { text: 'Action', value: 'actions', sortable: true }
      ],
      tableData: [],
      isLoading: false
    }
  },

  async created () {
    await this.onFranchiseeChange()
  },
  watch: {
    franchisee: async function (val) {
      this.companyName = val.companyName
      await this.onFranchiseeChange()
    },
    toDate: async function (val) {
      await this.onFranchiseeChange()
    },
    fromDate: async function (val) {
      await this.onFranchiseeChange()
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee'
    })
  },
  methods: {
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        Utils.helper.openDrawer(this, !this.franchiseeID)
        if (this.franchiseeID) {
          await this.onStart()
        }
        this.inProgress = false
      }
    },
    onStart: async function () {
      if (!this.franchiseeID) {
        return this.$dialog.error({
          text: 'Please select Franchisee',
          title: 'Error'
        })
      }

      try {
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/franchisee-orders?franchiseeID=${this.franchiseeID}&fromDate=${this.fromDate}&toDate=${this.toDate}`)
        this.tableData = data
        _.map(this.tableData, (obj, key) => {
          obj.index = key + 1
          obj.amount = Number(obj.amount / 100).toFixed(2)
          obj.createdAt = new Date(obj.createdAt).toLocaleString()
          obj.receiptNo = obj.receiptNo ? obj.receiptNo : 'N/A'
          obj.notes = obj.notes || {}
        })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
      }
    },
    isPendingOrder (item) {
      return (item.status === constants.PAYMENT_STATUS.initiated) || (item.status === constants.PAYMENT_STATUS.wait)
    },
    dialogClicked: async function (value) {
      console.log('value--', value)
      switch (value.dialog.id) {
        case this.dialogObj.types.payment:
          if (value.isSuccess) {
            Object.assign(this.dialogObj, {
              isLoadingYes: true
            })
            await this.reject()
          }
      }
      Object.assign(this.dialogObj, {
        show: false,
        isLoadingYes: false,
        isLoadingNo: false
      })
    },
    openDialog (type, orderid) {
      Object.assign(this.dialogObj, {
        id: type,
        show: true,
        title: 'Are You Sure Want Reject This Order ?',
        subtitle: 'If you click "Yes" then this order will reject.'
      })
      this.selectedOrderID = orderid
    },
    reject: async function () {
      try {
        this.isLoading = true
        const orderID = this.selectedOrderID
        await http.patch(`${constants.API_URL}/api/payments/reject/order`, orderID)

        this.isLoading = false
        this.dialog1 = false
        this.model = 0
        this.$dialog.info({
          text: `Online Payment Rejected !!`,
          title: 'Rejected'
        })
        await this.onStart()
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message

        console.log('error in fetching data : ', errorMessage)
        this.dialog1 = false
        return this.$dialog.error({
          text: ` ${errorMessage}`,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>
